import React, { useState } from "react";
import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
  Toolbar,
  CardMedia,
  Modal,
} from "@mui/material";
import { NavLink, useNavigate } from "react-router-dom";
import { INTERVIEW_BOT_COMPANY_IDS } from "../view/user/nipponBot/constants";
import {
  Menu,
  LayoutDashboard,
  Settings,
  User,
  Mic,
  Puzzle,
  Headphones,
  FileVolume2,
  Users,
  Building2,
  ReceiptIndianRupeeIcon,
  GraduationCap,
} from "lucide-react";
import CloseIcon from "@mui/icons-material/Close";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import BarChartIcon from "@mui/icons-material/BarChart";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PersonIcon from "@mui/icons-material/Person";
import LeaderboardOutlinedIcon from "@mui/icons-material/LeaderboardOutlined";
import Person3OutlinedIcon from "@mui/icons-material/Person3Outlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { jwtDecode } from "jwt-decode";
import ConvozeImg from "../assets/Convosecolorblackhori.svg";
import ConvozeLogo from "../assets/ConvozeLogo.png";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { theme as colorTheme } from "../Convoze.theme";
import GridOnOutlinedIcon from '@mui/icons-material/GridOnOutlined';

const DRAWER_WIDTH = 295;
const RAIL_WIDTH = 90;
const primary = "#7635DC";
const primaryBg = "#E9DFF9";

export default function Sidebar() {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [railOpen, setRailOpen] = useState(false);
  const [logoutOpen, setLogoutOpen] = useState(false);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : {};

  const handleLogoutClose = () => setLogoutOpen(false);
  const handleLogoutConfirm = () => {
    localStorage.clear();
    navigate("/");
  };
  const handleDrawerToggle = () => setMobileOpen((s) => !s);
  const toggleRail = () => setRailOpen((s) => !s);
  const closeRail = () => setRailOpen(false);

  const navigationItems = [
    {
      text: "Dashboard",
      icon: <LayoutDashboard size={18} />,
      path: "/user/dashboard",
      role: ["Manager", "Admin", "QualityAnalyst", "Curator"],
    },
    {
      text: "Performance",
      icon: <BarChartIcon sx={{ fontSize: 18 }} />,
      path: "/user/performance",
      role: ["Manager", "Admin", "QualityAnalyst", "Curator"],
      companyIds: ["69fdafaff0596b391f8be07b"],
    },
    // {
    //   text: "mPokket DB",
    //   icon: <BarChartIcon sx={{ fontSize: 18 }} />,
    //   path: "/user/mpokket-dashboard",
    //   role: ["Manager", "Admin"],
    // },
    {
      text: "Upload audio",
      icon: <FileVolume2 size={18} />,
      path: "/user/audio",
      role: ["Manager", "Admin", "BranchManager", "QualityAnalyst", "Curator"],
    },
    {
      text: "Interactions",
      icon: <Puzzle size={18} />,
      path: "/user/audio-details",
      role: ["Manager", "Admin", "BranchManager", "QualityAnalyst", "Curator"],
    },
    {
      text: "Candidates",
      icon: <Users size={18} />,
      path: "/user/bot-interviews/candidates",
      role: ["Manager", "Admin", "Curator"],
      companyIds: INTERVIEW_BOT_COMPANY_IDS,
    },
    {
      text: "Interviews",
      icon: <Headphones size={18} />,
      path: "/user/bot-interviews/interviews",
      role: ["Manager", "Admin", "Curator"],
      companyIds: INTERVIEW_BOT_COMPANY_IDS,
    },
    {
      text: "Calls",
      icon: <LocalPhoneOutlinedIcon sx={{ fontSize: 18 }} />,
      path: "/user/bot-interviews/calls",
      role: ["Manager", "Admin", "Curator"],
      companyIds: INTERVIEW_BOT_COMPANY_IDS,
    },
    {
      text: "Candidates",
      icon: <Users size={18} />,
      path: "/user/bot-interviews/branch-candidates",
      role: ["BranchManager"],
      companyIds: INTERVIEW_BOT_COMPANY_IDS,
    },
    {
      text: "Branch Managers",
      icon: <Users size={18} />,
      path: "/user/bot-interviews/branch-managers",
      role: ["Manager", "Admin", "Curator"],
      companyIds: INTERVIEW_BOT_COMPANY_IDS,
    },
    {
      text: "Bot Interviews",
      icon: <Mic size={18} />,
      path: "/user/bot-interviews",
      role: ["Curator"],
      companyIds: INTERVIEW_BOT_COMPANY_IDS,
    },
    // {
    //   text: "Voice Capture",
    //   icon: <Mic size={18} />,
    //   path: "/user/voice-capture",
    //   role: ["Manager", "Admin"],
    // },
    // {
    //   text: "LeaderBoard",
    //   icon: <LeaderboardOutlinedIcon sx={{ fontSize: 18 }} />,
    //   path: "/user/leaderboard",
    //   role: ["Manager", "Admin"],
    // },
    // {
    //   text: "View Agents",
    //   icon: <Person3OutlinedIcon sx={{ fontSize: 18 }} />,
    //   path: "/user/agent/list",
    //   role: ["Manager", "Admin"],
    // },
    {
      text: "User Management",
      icon: <User size={18} />,
      path: "/user/user-management",
      role: ["Manager", "Admin", "Curator"],
    },
    {
      text: "My Profile",
      icon: <Person3OutlinedIcon sx={{ fontSize: 18 }} />,
      path: "/user/setting",
      role: ["Manager", "Admin", "Curator"],
    },
    {
      text: "Settings",
      icon: <Settings size={18} />,
      path: "/user/settings",
      role: ["Manager", "Admin", "QualityAnalyst", "Curator"],
    },
    {
      text: "Account",
      icon: <AccountCircleOutlinedIcon sx={{ fontSize: 18 }} />,
      path: "/user/account/manage",
      role: ["Manager", "Admin", "Curator"],
    },
    {
      text: "Billing",
      icon: <ReceiptIndianRupeeIcon size={18} />,
      path: "/user/billing",
      role: ["Manager", "Admin"],
      userIds: ["6a3037a95062c47ab067cc2e"],
    },
    // {
    //   text: "Dashboard",
    //   icon: <LayoutDashboard size={18} />,
    //   path: "/super-admin/dashboard",
    //   role: ["SuperAdmin"],
    // },
    {
      text: "Process Management",
      icon: <GridOnOutlinedIcon size={18} />,
      path: "/super-admin/process-management",
      role: ["SuperAdmin"],

    },
    {
      text: "Client Management",
      icon: <GridOnOutlinedIcon size={18} />,
      path: "/super-admin/client-management",
      role: ["SuperAdmin"],

    },
    {
      text: "Create Agent",
      icon: <User size={18} />,
      path: "/super-admin/agent-create",
      role: ["SuperAdmin"],
    },
    // {
    //   text: "User Management",
    //   icon: <Users size={18} />,
    //   path: "/super-admin/user-management",
    //   role: ["SuperAdmin"],
    // },
    // {
    //   text: "Company Access",
    //   icon: <Building2 size={18} />,
    //   path: "/super-admin/company-access",
    //   role: ["SuperAdmin"],
    // },
    {
      text: "Billing Analytics",
      icon: <ReceiptIndianRupeeIcon size={18} />,
      path: "/super-admin/billing",
      role: ["SuperAdmin"],
    },
    {
      text: "Dashboard",
      icon: <HomeOutlinedIcon sx={{ fontSize: 18 }} />,
      path: "/agent/dashboard",
      role: ["Agent"],
    },
    {
      text: "My Calls",
      icon: <LocalPhoneOutlinedIcon sx={{ fontSize: 18 }} />,
      path: "/agent/my-calls",
      role: ["Agent"],
    },
    {
      text: "My KPIs",
      icon: <BarChartIcon sx={{ fontSize: 18 }} />,
      path: "/agent/my-kpis",
      role: ["Agent"],
    },
    {
      text: "LeaderBoard",
      icon: <PersonIcon sx={{ fontSize: 18 }} />,
      path: "/agent/leaderboard",
      role: ["Agent"],
    },
    {
      text: "Settings",
      icon: <Settings size={18} />,
      path: "/agent/settings",
      role: ["Agent"],
    },

    // after your last real item
    {
      text: "Logout",
      icon: <LogoutOutlinedIcon sx={{ fontSize: 18 }} />,
      path: "",
      role: ["Manager", "Admin", "SuperAdmin", "Agent", "BranchManager", "QualityAnalyst", "Curator"],
    },
  ];

  const filteredItems = navigationItems.filter((item) => {
    const roleMatch = item.role.includes(decodedToken?.userRole);
    if (!roleMatch) return false;
    if (item.companyIds?.length && !item.companyIds.includes(decodedToken?.companyId)) return false;
    if (item.userIds?.length && !item.userIds.includes(decodedToken?.userId)) return false;

    const isNipponBotCompany = INTERVIEW_BOT_COMPANY_IDS.includes(decodedToken?.companyId);
    if (isNipponBotCompany) {
      if (item.text === "Interactions" && decodedToken?.userRole !== "Curator") return false;
      if (item.text === "Bot Interviews" && decodedToken?.userRole !== "Curator") return false;
      if (item.text === "User Management") return false;
      if (item.text === "Upload audio" && decodedToken?.userRole === "BranchManager") return false;
    }

    if (item.text === "Upload audio" && decodedToken?.userRole !== "BranchManager" && decodedToken?.userRole !== "QualityAnalyst") {
      const allowed = ["67e560a6ae2e0d3f96b5eb02", "67e560a6ae2e0d3f96b5eb01", "67e560a6ae2e0d3f96b5eb05", "67e560a6ae2e0d3f96b5eb03", "67e560a6ae2e0d3f96b5eb06", "6981acd725927379deebdf1c", "69a5457a13825f7ed1eed210", "69a544f113825f7ed1eed1ea", "69a5449b13825f7ed1eed1c2", "69a5440c13825f7ed1eed19c", "69fdafaff0596b391f8be07b", "6a2297b82066927562831874"];
      return allowed.includes(decodedToken?.companyId);
    }
    return true;
  });
  //   const filteredItems = navigationItems.filter((item) => {
  //   const roleMatch = item.role.includes(decodedToken?.userRole);
  //   if (!roleMatch) return false;

  //   if (item.text === "Upload audio") {
  //     return true; // allow for every companyId
  //   }

  //   return true;
  // });

  const RailOpenList = () => (
    <List sx={{ px: 2.5, py: 2 }}>
      {filteredItems.map((item) => (
        <ListItem key={item.text} disablePadding sx={{ mb: 1 }}>
          <ListItemButton
            component={NavLink}
            to={item.path}
            end={item.path === "/user/bot-interviews"}
            onClick={() => {
              if (item.text === "Logout") {
                setLogoutOpen(true);
                return;
              }
              isMobile && setMobileOpen(false);
              navigate(item.path);
            }}
            sx={{
              minHeight: 48,
              borderRadius: 1.5,
              gap: 1.5,
              "&.active": {
                backgroundColor: `#F4EFFC`,
                color: "#7635DC",
                "& .MuiListItemIcon-root": { color: "#7635DC" },
              },
            }}
          >
            <ListItemIcon
              sx={{ color: "inherit", minWidth: "auto", fontSize: "1.5rem" }}
            >
              {item.icon}
            </ListItemIcon>

            <ListItemText
              primary={item.text}
              sx={{
                fontSize: "0.875rem",
                lineHeight: 1.57143,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
          </ListItemButton>
        </ListItem>
      ))}

      {/* <ListItem disablePadding sx={{ mt: 2 }}>
        <ListItemButton
          onClick={() => {
            isMobile ? setMobileDrawerOpen(false) : closeRail();
            setLogoutOpen(true);
          }}
          sx={{
            minHeight: 48,
            borderRadius: 1.5,
            gap: 1.5,
            '&:hover': { bgcolor: 'rgba(0, 171, 85, 0.08)' },
          }}
        >
          <ListItemIcon sx={{ minWidth: 'auto' }}>
            <LogoutIcon size={16} />
          </ListItemIcon>

          <ListItemText
            primary="Logout"
            sx={{
              fontSize: '0.875rem',
              lineHeight: 1.57143,
              fontWeight: 600,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}

          />
        </ListItemButton>
      </ListItem> */}
    </List>
  );

  /* ---------- DESKTOP DRAWER ---------- */
  const desktopDrawer = (
    <Drawer
      variant="permanent"
      sx={{
        position: "relative",
        display: { xs: "none", md: "block" },
        width: railOpen ? DRAWER_WIDTH : RAIL_WIDTH,
        flexShrink: 0,
        position: "relative",
        "& .MuiDrawer-paper": {
          width: railOpen ? DRAWER_WIDTH : RAIL_WIDTH,
          boxSizing: "border-box",
          borderRight: "1px solid #e5e7eb",
          overflowX: "hidden",
          transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.shortest,
          }),
        },
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          minHeight: 72,
          display: "flex",
          alignItems: "center",
          justifyContent: railOpen ? "space-between" : "space-between",
          px: 2,
        }}
      >
        <CardMedia
          component="img"
          src={railOpen ? ConvozeImg : ConvozeLogo}
          alt="logo"
          sx={{ width: railOpen ? 150 : 30, height: "auto" }}
        />

        <IconButton
          onClick={toggleRail}
          sx={{
            // position:'absolute',
            zIndex: 1000,
            backgroundColor: "#f3f3f3",
            color: "#333",
            boxShadow: 1,
            width: railOpen ? 32 : 16,
            height: railOpen ? 32 : 16,
            // right:-17,
            "&:hover": { backgroundColor: "#e0e0e0" },
          }}
        >
          {railOpen ? (
            <ChevronLeftIcon sx={{ fontSize: 18 }} />
          ) : (
            <ChevronRightIcon sx={{ fontSize: 18 }} />
          )}
        </IconButton>
      </Toolbar>

      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          overflowX: "hidden",
          "&::-webkit-scrollbar": railOpen ? { width: 6 } : { display: "none" },
          "&::-webkit-scrollbar-track": { bgcolor: "transparent" },
          padding: railOpen ? 0 : 0.8,
        }}
      >
        {railOpen ? (
          <RailOpenList />
        ) : (
          <List
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 0.5,
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            {filteredItems?.map((item) => (
              <ListItem key={item.text} disablePadding>
                <ListItemButton
                  component={NavLink}
                  to={item.path}
                  end={item.path === "/user/bot-interviews"}
                  onClick={() => {
                    if (item.text === "Logout") {
                      setLogoutOpen(true);
                      return;
                    }
                    isMobile ? setMobileOpen(false) : closeRail();
                    navigate(item.path);
                  }}
                  sx={{
                    borderRadius: 2,
                    flexDirection: "column",
                    gap: 1,
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#637381",
                    fontWeight: 600,

                    WebkitBoxOrient: "vertical",
                    textOverflow: "ellipsis",
                    lineHeight: "16px",
                    fontSize: "0.625rem",
                    "&.active": {
                      backgroundColor: `#F4EFFC`,
                      color: primary,
                      "& .MuiListItemIcon-root": { color: "#7635DC" },
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      color: "inherit",
                      minWidth: "auto",
                      mb: 0.25,
                      fontWeight: 700,
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>
                  <Typography
                    sx={{
                      fontSize: "0.625rem",
                      lineHeight: 1,
                      fontWeight: 600,
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      color: "inherit",
                      textAlign: "center",
                      whiteSpace: "wrap",
                      overflow: 'hidden',

                    }}
                  >
                    {item.text}
                  </Typography>
                </ListItemButton>
              </ListItem>
            ))}

            {/* <ListItem disablePadding>
              <ListItemButton
                onClick={() => {
                  isMobile ? setMobileOpen(false) : closeRail();
                  setLogoutOpen(true);
                }}
                sx={{
                  borderRadius: 2,
                  minHeight: 56,
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <ListItemIcon sx={{ color: 'inherit', minWidth: 'auto', mb: 0.25 }}>
                  <LogoutIcon fontSize="small" />
                </ListItemIcon>
                <Typography sx={{ fontSize: '8px', lineHeight: 1, color: 'inherit', textAlign: 'center', maxWidth: 34, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  Logout
                </Typography>
              </ListItemButton>
            </ListItem> */}
          </List>
        )}
      </Box>
    </Drawer>
  );

  /* ---------- MOBILE DRAWER ---------- */
  const mobileDrawer = (
    <Drawer
      variant="temporary"
      open={mobileDrawerOpen}
      onClose={() => setMobileDrawerOpen(false)}
      ModalProps={{ keepMounted: true }}
      sx={{
        display: { xs: "block", md: "none" },
        "& .MuiDrawer-paper": {
          boxSizing: "border-box",
          width: DRAWER_WIDTH,
          borderRight: "1px solid #e5e7eb",
          zIndex: 99999,
        },
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          minHeight: 72,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <CardMedia
          component="img"
          src={ConvozeLogo}
          alt="logo"
          sx={{ height: 24, marginLeft: 4, width: "auto" }}
        />
      </Toolbar>

      <Box sx={{ flexGrow: 1, overflowY: "auto", overflowX: "hidden" }}>
        <RailOpenList />
      </Box>
    </Drawer>
  );

  /* ---------- MOBILE menu bar ---------- */
  const mobileTopBar = isMobile && !mobileDrawerOpen && (
    <Toolbar
      sx={{
        position: "fixed",
        top: -15,
        left: 0,
        zIndex: 9999,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        minHeight: 56,
      }}
    >
      <IconButton onClick={() => setMobileDrawerOpen(true)}>
        <Menu />
      </IconButton>
    </Toolbar>
  );

  /* ---------- LOGOUT MODAL ---------- */
  const logoutModal = (
    <Modal open={logoutOpen} onClose={handleLogoutClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 360,
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 4,
          p: 4,
          textAlign: "center",
        }}
      >
        <Typography variant="h6" mb={3}>
          Are you sure you want to logout?
        </Typography>
        <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
          <Button variant="outlined" onClick={handleLogoutClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{ backgroundColor: primary }}
            onClick={handleLogoutConfirm}
          >
            Logout
          </Button>
        </Box>
      </Box>
    </Modal>
  );

  return (
    <>
      {mobileTopBar}
      {desktopDrawer}
      {mobileDrawer}
      {logoutModal}
    </>
  );
}

// import React, { useState } from "react";
// import {
//   Box,
//   Drawer,
//   IconButton,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Typography,
//   Button,
//   useTheme,
//   useMediaQuery,
//   Avatar,
//   Menu as MuiMenu,
//   Modal,
//   Tooltip,
// } from "@mui/material";
// import { NavLink, useNavigate } from "react-router-dom";
// import {
//   Menu,
//   LayoutDashboard,
//   Settings,
//   User,
//   Puzzle,
//   FileVolume2,
//   Users,
//   Building2,
//   ReceiptIndianRupee,
//   ReceiptIndianRupeeIcon,
//   GraduationCap,
// } from "lucide-react";
// import ProfileImg from "../../src/assets/user.png";
// import ProfileMenu from "./ProfileMenu";
// import { jwtDecode } from "jwt-decode";
// import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
// import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
// import BarChartIcon from "@mui/icons-material/BarChart";
// import AssignmentIcon from "@mui/icons-material/Assignment";
// import PersonIcon from "@mui/icons-material/Person";
// import convozeIcon from "../assets/Convosecolorblackhori.svg";
// import LogoutIcon from "@mui/icons-material/Logout";
// import animationData from "../assets/lottie/hello animation.json";
// import LeaderboardOutlinedIcon from "@mui/icons-material/LeaderboardOutlined";
// import Lottie from "lottie-react";
// import Person3OutlinedIcon from "@mui/icons-material/Person3Outlined";
// import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
// import {palette, theme as colorTheme} from "../../src/Convoze.theme"

// const primary = colorTheme("palette", "primary").value;
// const primaryBg = colorTheme("palette", "primaryBg").value;

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 400,
//   bgcolor: "background.paper",
//   boxShadow: 24,
//   p: 5,
//   borderRadius: 6,
// };

// const DRAWER_WIDTH = 280;

// export default function Sidebar() {
//   const theme = useTheme();
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [logoutOpen, setLogoutOpen] = useState(false);
//   const [openModel, setOpenModel] = React.useState(false);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const navigate = useNavigate();
//   const handleLogoutOpen = () => setLogoutOpen(true);
//   const handleLogoutClose = () => setLogoutOpen(false);
//   const handleLogoutConfirm = () => {
//     navigate("/");
//     localStorage.clear();
//   };

//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
//   const token = localStorage.getItem("token");
//   const decodedToken = token ? jwtDecode(token) : "";

//   const handleOpen = () => setOpenModel(true);
//   const handleClose = () => setOpenModel(false);
//   const open = Boolean(anchorEl);

//   const handleMenuClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };
//   const handleMenuClose = () => {
//     setAnchorEl(null);
//   };

//   const handleDrawerToggle = () => {
//     setMobileOpen(!mobileOpen);
//   };

//   const navigationItems = [
//     {
//       text: "Dashboard",
//       icon: <LayoutDashboard size={20} />,
//       path: "/user/dashboard",
//       role: ["Manager", "Admin"],
//     },
//     {
//       text: "Upload audio",
//       icon: <FileVolume2 size={20} />,
//       path: "/user/audio",
//       role: ["Manager", "Admin"],
//     },
//     {
//       text: "Interactions",
//       icon: <Puzzle size={20} />,
//       path: "/user/audio-details",
//       role: ["Manager", "Admin"],
//     },
//     {
//       text: "LeaderBoard",
//       icon: <LeaderboardOutlinedIcon size={20} />,
//       path: "/user/leaderboard",
//       role: ["Manager", "Admin"],
//     },
//     {
//       text: "View Agents",
//       icon: <Person3OutlinedIcon size={20} />,
//       path: "/user/agent/list",
//       role: ["Manager", "Admin"],
//     },
//     {
//       text: "User Management",
//       icon: <User size={20} />,
//       path: "/user/user-management",
//       role: ["Manager", "Admin"],
//     },
//      {
//       text: "Training",
//       icon: <GraduationCap size={20} />,
//       path: "/user/training",
//       role: ["Manager", "Admin"],
//     },
//     {
//       text: "Billing",
//       icon: <PaidOutlinedIcon size={20} />,
//       path: "/user/billing",
//       role: ["Manager", "Admin"],
//     },
//     {
//       text: "My Profile",
//       icon: <Person3OutlinedIcon size={20} />,
//       path: "/user/setting",
//       role: ["Manager", "Admin"],
//     },
//     {
//       text: "Settings",
//       icon: <Settings size={20} />,
//       path: "/user/settings",
//       role: ["Manager", "Admin"],
//     },

//     // Super admin routes
//     {
//       text: "Dashboard",
//       icon: <LayoutDashboard size={20} />,
//       path: "/super-admin/dashboard",
//       role: ["SuperAdmin"],
//     },
//     {
//       text: "User Management",
//       icon: <Users size={20} />,
//       path: "/super-admin/user-management",
//       role: ["SuperAdmin"],
//     },
//     {
//       text: "Company Access",
//       icon: <Building2 size={20} />,
//       path: "/super-admin/company-access",
//       role: ["SuperAdmin"],
//     },
//     {
//       text: "Billing Analytics",
//       icon: <ReceiptIndianRupeeIcon size={20} />,
//       path: "/super-admin/billing",
//       role: ["SuperAdmin"],
//     },

//     // Agent routes
//     {
//       text: "Dashboard",
//       icon: <HomeOutlinedIcon size={20} />,
//       path: "/agent/dashboard",
//       role: ["Agent"],
//     },
//     {
//       text: "My Calls",
//       icon: <LocalPhoneOutlinedIcon size={20} />,
//       path: "/agent/my-calls",
//       role: ["Agent"],
//     },
//     {
//       text: "My KPIs",
//       icon: <BarChartIcon size={20} />,
//       path: "/agent/my-kpis",
//       role: ["Agent"],
//     },
//     {
//       text: "LeaderBoard",
//       icon: <PersonIcon size={20} />,
//       path: "/agent/leaderboard",
//       role: ["Agent"],
//     },
//     {
//       text: "Settings",
//       icon: <Settings size={20} />,
//       path: "/agent/settings",
//       role: ["Agent"],
//     },
//   ];
//   const filteredItems = navigationItems?.filter((item) => {
//     const roleMatch = item.role.includes(decodedToken?.userRole);

//     if (!roleMatch) return false;

//     // Extra condition for Upload audio
//     if (item?.text === "Upload audio") {
//       const allowedCompanyIds = [
//         "67e560a6ae2e0d3f96b5eb02", // us
//         "67e560a6ae2e0d3f96b5eb01", // demo account
//         // "67e560a6ae2e0d3f96b5eb10", //phonepay
//       ];
//       return allowedCompanyIds?.includes(decodedToken?.companyId);
//     }

//     return true;
//   });

//   // const navigationItems = [
//   //   //Manager routes
//   //   {
//   //     text: "Dashboard",
//   //     icon: <LayoutDashboard size={20} />,
//   //     path: "/user/dashboard",
//   //     role: "Manager" || "Admin",
//   //   },
//   //   {
//   //     text: "Upload audio",
//   //     icon: <FileVolume2 size={20} />,
//   //     path: "/user/audio",
//   //     role: "Manager" || "Admin",
//   //   },
//   //   {
//   //     text: "Interactions",
//   //     icon: <Puzzle size={20} />,
//   //     path: "/user/audio-details",
//   //     role: "Manager" || "Admin",
//   //   },
//   //   {
//   //     text: "LeaderBoard",
//   //     icon: <LeaderboardOutlinedIcon size={20} />,
//   //     path: "/user/leaderboard",
//   //     role: "Manager" || "Admin",
//   //   },
//   //   {
//   //     text: "View Agents",
//   //     icon: <Person3OutlinedIcon size={20} />,
//   //     path: "/user/agent/list",
//   //     role: "Manager" || "Admin",
//   //   },
//   //   {
//   //     text: "User Management",
//   //     icon: <User size={20} />,
//   //     path: "/user/user-management",
//   //     role: "Manager" || "Admin " || "Agent",
//   //   },

//   //   {
//   //     text: "Billing",
//   //     icon: <PaidOutlinedIcon size={20} />,
//   //     path: "/user/billing",
//   //     role: "Manager" || "Admin",
//   //   },
//   //   {
//   //     text: "My Profile",
//   //     icon: <Person3OutlinedIcon size={20} />,
//   //     path: "/user/setting",
//   //     role: "Manager" || "Admin",
//   //   },
//   //   {
//   //     text: "Settings",
//   //     icon: <Settings size={20} />,
//   //     path: "/user/settings",
//   //     role: "Manager" || "Admin",
//   //   },

//   //   //Admin routes
//   //   {
//   //     text: "Dashboard",
//   //     icon: <LayoutDashboard size={20} />,
//   //     path: "/user/dashboard",
//   //     role: "Admin",
//   //   },
//   //   {
//   //     text: "Upload audio",
//   //     icon: <FileVolume2 size={20} />,
//   //     path: "/user/audio",
//   //     role: "Admin",
//   //   },
//   //   {
//   //     text: "Interactions",
//   //     icon: <Puzzle size={20} />,
//   //     path: "/user/audio-details",
//   //     role: "Admin",
//   //   },
//   //   {
//   //     text: "Settings",
//   //     icon: <Settings size={20} />,
//   //     path: "/user/setting",
//   //     role: "Admin",
//   //   },

//   //   // super admin routes
//   //   {
//   //     text: "Dashboard",
//   //     icon: <LayoutDashboard size={20} />,
//   //     path: "/super-admin/dashboard",
//   //     role: "SuperAdmin",
//   //   },
//   //   {
//   //     text: "User Management",
//   //     icon: <Users size={20} />,
//   //     path: "/super-admin/user-management",
//   //     role: "SuperAdmin",
//   //   },
//   //   {
//   //     text: "Company Access",
//   //     icon: <Building2 size={20} />,
//   //     path: "/super-admin/company-access",
//   //     role: "SuperAdmin",
//   //   },
//   //   {
//   //     text: "Billing Analytics",
//   //     icon: <ReceiptIndianRupeeIcon size={20} />,
//   //     path: "/super-admin/billing",
//   //     role: "SuperAdmin",
//   //   },
//   //   // Agent routes
//   //   {
//   //     text: "Dashboard",
//   //     icon: <HomeOutlinedIcon size={20} />,
//   //     path: "/agent/dashboard",
//   //     role: "Agent",
//   //   },
//   //   {
//   //     text: "My Calls",
//   //     icon: <LocalPhoneOutlinedIcon size={20} />,
//   //     path: "/agent/my-calls",
//   //     role: "Agent",
//   //   },
//   //   {
//   //     text: "My KPIs",
//   //     icon: <BarChartIcon size={20} />,
//   //     path: "/agent/my-kpis",
//   //     role: "Agent",
//   //   },
//   //   // {
//   //   //   text: "Daily Tasks",
//   //   //   icon: <AssignmentIcon size={20} />,
//   //   //   path: "/agent/daily-tasks",
//   //   //   role: "Agent",
//   //   // },
//   //   {
//   //     text: "Leaderboard",
//   //     icon: <PersonIcon size={20} />,
//   //     path: "/agent/leaderboard",
//   //     role: "Agent",
//   //   },
//   //   {
//   //     text: "Settings",
//   //     icon: <Settings size={20} />,
//   //     path: "/agent/settings",
//   //     role: "Agent",
//   //   },
//   //   // {
//   //   //   text: "Logout",
//   //   //   icon: <LogoutIcon size={20} />,
//   //   //   path: "",
//   //   //   role: "Agent" || "SuperAdmin" || "Admin" || "Manager",
//   //   // },
//   // ];

//   // // const filteredItems = navigationItems?.filter((item) => {
//   // //   return item?.role == decodedToken?.userRole;
//   // // });

//   // const filteredItems = navigationItems.filter((item) => {
//   //   const roleMatch = item.role.includes(decodedToken?.userRole);

//   //   if (!roleMatch) return false;

//   //   // Extra condition for Upload audio
//   //   if (item.text === "Upload audio") {
//   //     const allowedCompanyIds = [
//   //       "67e560a6ae2e0d3f96b5eb02", //us
//   //       // "67e560a6ae2e0d3f96b5eb10", //phonepay
//   //       "67e560a6ae2e0d3f96b5eb01", //demo account
//   //     ];
//   //     return allowedCompanyIds.includes(decodedToken?.companyId);
//   //   }

//   //   return true;
//   // });

//   const drawer = (
//     <Box
//       sx={{
//         height: "100%",
//         display: "flex",
//         justifyContent:"flex-start",
//         flexDirection: "column",
//         bgcolor: "#ffffff",
//         color: "white",
//         borderRight: "1px solid #d2d2d2",
//       }}
//     >
//        <Box
//         sx={{
//           p: "20px 25px 13px 22px",
//           display: "flex",
//           alignItems: "center",
//         }}
//       >
//         <Box
//           sx={{
//             width: "100%",
//             display: "flex",
//             justifyContent: "center",
//           }}
//         >
//           <img
//             src={
//               convozeIcon ||
//               "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGkAAABpCAYAAAA5gg06AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAU1SURBVHgB7Z3NbhtVFMf/d+xILM2GbV0k1iRSQSA1rbNgTd8A9wFQ0hcgyRNAFqzj7JHaPkGmHwgokZIHQKr7BEQs8cflnGs7SvyViT1z5wz6/yQ7djxdND+fc8/9mHsBYh4HS5z6BurYxRBtWMGhO351IY8P8v4CfXnsuEtEwpak1/5YntuoAl5EOaTyeIltl6JA7EjSKKrhb1STrvwlOxJhJxJhXeSMJUlNkfQe1aeDAQ7zlJWA5E07fNk0desXLwcoqThU1jne+H2sCdNdHLqSAndWTYGMpDg0Q1S99m2sACXFoyGP41XSHyXFxuPgrqIoqQxU1KjjnglKKo921oiipDLJmPooqWxU1KlvLbuEkixQw/NloxOUZAMdXF5YSFCSHVpS8e3N+4CSbLEfpmymoCRbNMTITDRRkjUcdqejiZLsMRNNlGSRqWiiJJtoSd6evKEku3w7eUFJdmlNUh4lWaaGJ/qDkmzzWJ8oyTYtfaIk2zS1XaIk+zQpyTo1bFKSdTwjyT4O9yipAlBSBagjEuct3+j9i6ZzUvsnuKe51nts6mfyu6b7Ad0Hb1ypNxB887Pf/Ocj7P/x2ainb4VC/ygqpt+T0VwXBgtVSGPRtaJHJd2HAe7/4k/ffzLqSBqgU0gknW37JxIlu/2+/Edt3ZWbCRF0BJiRlF+6C1HTl8kqYE8ENVBlHC4lHdvA40Mukt5t+3avh31tW0DyRZqBtST99pVv1us4FtuVTGuVYIDuyiX4u4d+VwSdw1Du/p9ycedI0rZn0MOPviqbYlQZP9p55U6SNL1J23PKticSLmyVk33EQQXVahQUmVf6lEkSBZXEAKn+uFUSBZVGOtn3YakkLRIoqDROJi+WStIqjoJKwKOLR64zebuwutN+EMvsknCjtmjC3EjSdkgGEH4CKQfdiu0acyXJSMJzkHLws3vlzUjSwVKM5n5IbLQtGqIz/evZSBpi7f3ZyIq4+TtO3pCkUcRqrjQ61yu669yMJEZROfiwaeHhoo+vJDGKSsTh2bJdJa8kOY/vQOKj1dwj92LZJUGS9ovAybv4qKDH7uC2y4Kk2gYFRcfjKIsgJUhiqovMKIL2sl4+aZNaIHHImOKuU//z4fIN8UhOeFxKFfdUBL246z9NBp5DQBFIpQ+6dVsVt4h6wr5RcYyiR0vstWYUxBE+BymCzjh61p7y0Um/aq/btocezXMkIwgXyAmt7powgPdo6poKVBEfFvgfipyPJXKe5ilIMRVJ/UEY4H2GapCKmFeS0nRVT4oCiXanXyY89s62fWMo6WIwRLSDDaf5/i/g7NOrAxcvw+GLPhy6qKPVGiVxD16UfpKVO3EskX7x1u3ACLyxuQIk3l+FNTFK4lx5uZ9kQ9NdF8Q0idejoolpksmNSsQuyaB3c90xsUfy9e9hlQqLB8OEfpKU4S9BzJKMn1MQswRJGzXojCFTnlGCpK00DBamICa5PnZ3BGKSK0ky6puC0WSS6VHwQxBz3JDEaLLJvPkkRpMxZiRpNDkWEaaYOzNbq+OAk4F2mCtJ+01O1y0TEyxc4zAuItg+GWDpQhQRpWnvBKRUbl0ttLERDqblxGCJ3CpJ26d6HboGjaJKItO6O4oql8yLI1WUtFFb7EPF584rWB+8DTfksuqLyErLjLXq6/dxnx3eOKy8FlwXsEjltwVGVeGstWB/3E5Noor9qYLI5a4Kjaovf3VtyiqGXG99uSFLqsCqtll6KhoMUfiBOrqZxxBoJaPD1lswjpMvVm+AnfGiURP8BwDIlSd/wd8IAAAAAElFTkSuQmCC"
//             }
//             style={{ width: "100%", height: 40 }}
//             alt="Logo"
//           />
//         </Box>
//       </Box>

//       {/* Workspace Selector */}
//        <Box sx={{ px: 3, mb: 2 }}>
//         <Button
//           fullWidth
//           sx={{
//             justifyContent: "space-between",
//             color: "white",
//             bgcolor: "rgba(255, 255, 255, 0.04)",
//             borderRadius: 3,
//             border: "1px solid #4B4B4B",
//             "&:hover": {
//               bgcolor: "rgba(255, 255, 255, 0.08)",
//             },
//           }}
//         >
//           <Box sx={{ textAlign: "left", p: "0px 5px" }}>
//             <Typography
//               sx={{
//                 textTransform: "capitalize",
//                 color: "rgba(0, 0, 0, 0.79)",
//               }}
//             >
//               {decodedToken?.userName || ""}
//             </Typography>
//             <Typography
//               sx={{
//                 textTransform: "capitalize",
//                 // color: "#6366F1",
//                 color : primary,
//                 fontSize: 14,
//                 fontWeight: 600,
//               }}
//             >
//               {decodedToken?.userRole || ""}
//             </Typography>
//           </Box>
//         </Button>
//       </Box>

//       <Box
//         sx={{
//           borderTop: "1px solid #d2d2d2",
//           p: "5px 0 0px 0",
//         }}
//       ></Box>

//       <Box
//         sx={{
//           flex: 1,
//           display: "flex",
//           flexDirection: "column",
//           overflow: "hidden",
//         }}
//       >
//         <List
//           sx={{
//             px:1,
//             flex: 1,
//             overflowY: "auto",
//             "&::-webkit-scrollbar": { width: 4 },
//             "&::-webkit-scrollbar-track": { bgcolor: "transparent" },
//             "&::-webkit-scrollbar-thumb": {
//               // bgcolor: "#6366F1",
//               bgcolor : primary,
//               height: 40,
//               borderRadius: 4,
//             },
//             "&::-webkit-scrollbar-thumb:hover": {
//               // bgcolor: "#7c7fffff"
//               bgcolor: primary,
//              },
//           }}
//         >
//           {filteredItems?.map((item) => (
//             <ListItem key={item?.text} >

//                 <ListItemButton
//                   component={NavLink}
//                   to={item?.path}
//                   sx={{
//                     borderRadius: 2,
//                     "&.active": {
//                       // bgcolor: "rgb(99, 102, 241)",
//                       bgcolor: primary,
//                       "& .MuiListItemText-primary": {
//                         color: "white",
//                         fontWeight: 600,
//                       },
//                       "& .MuiListItemIcon-root": { color: "white" },
//                       "&:hover": {
//                         // bgcolor: "rgb(99, 102, 241)"
//                         bgcolor : primary,
//                       },
//                     },
//                     "&:hover": { bgcolor: "rgba(255, 255, 255, 0.04)" },
//                   }}
//                 >
//                   <ListItemIcon sx={{ color: "grey", minWidth:30 }}>
//                     {item?.icon}
//                   </ListItemIcon>

//                   <ListItemText
//                   primary={item?.text}
//                   sx={{
//                     "& .MuiListItemText-primary": {
//                       fontSize: "0.875rem",
//                       fontWeight: 100,
//                       color: "black",
//                     },
//                   }}
//                 />
//                 </ListItemButton>

//             </ListItem>
//           ))}

//           {/* Logout Button */}
//           <ListItem >
//             <ListItemButton
//               onClick={handleLogoutOpen}
//               sx={{
//                 borderRadius: 2,
//                 "&:hover": { bgcolor: "rgba(255, 255, 255, 0.04)" },
//               }}
//             >
//               <ListItemIcon sx={{ color: "grey", minWidth: 30 }}>
//                 <LogoutIcon fontSize="small" />
//               </ListItemIcon>
//               <ListItemText
//                 primary="Logout"
//                 sx={{
//                   "& .MuiListItemText-primary": {
//                     fontSize: "0.875rem",
//                     fontWeight: 100,
//                     color: "black",
//                   },
//                 }}
//               />
//             </ListItemButton>
//           </ListItem>
//         </List>
//       </Box>

//       <Box sx={{}}>
//         <Lottie
//           animationData={animationData}
//           loop
//           autoplay
//           style={{
//             width: "100%",
//             maxWidth: 180,
//             margin: "auto",
//             cursor: "pointer",
//           }}
//         />
//       </Box>
//     </Box>
//   );

//   return (
//     <Box>
//       {/* Mobile Header */}
//       {isMobile && (
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             color: "white",
//             // width: "100%",
//             borderBottom: "1px solid #eeeee4",
//           }}
//         >
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               // alignItems: "center",
//               p: "10px 20px",
//               width: "100%",
//             }}
//           >
//             {/* Menu Icon */}
//             <IconButton
//               color="inherit"
//               aria-label="open drawer"
//               edge="start"
//               onClick={handleDrawerToggle}
//             >
//               <Menu color="black" size={24} />
//             </IconButton>

//             {/* Profile Avatar */}
//             <Box>
//               {/* Menu Icon */}
//               <IconButton
//                 aria-label="open drawer"
//                 edge="start"
//                 onClick={handleMenuClick}
//               >
//                 {/* Profile Avatar */}
//                 <IconButton onClick={handleMenuClick}>
//                   <Avatar
//                     src={ProfileImg}
//                     alt="User Profile"
//                     sx={{ width: 29, height: 29 }}
//                   />
//                 </IconButton>
//               </IconButton>

//               {/* Menu for Menu Icon */}
//               <MuiMenu
//                 anchorEl={anchorEl}
//                 open={open}
//                 onClose={handleMenuClose}
//                 anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//                 transformOrigin={{ vertical: "top", horizontal: "right" }}
//               >
//                 <ProfileMenu setAnchorEl={setAnchorEl} />
//               </MuiMenu>
//             </Box>
//           </Box>
//         </Box>
//       )}

//       {/* Mobile Drawer */}
//       <Drawer
//         variant="temporary"
//         open={mobileOpen}
//         onClose={handleDrawerToggle}
//         ModalProps={{
//           keepMounted: true,
//         }}
//         sx={{
//           display: { xs: "block", md: "none" },
//           "& .MuiDrawer-paper": {
//             boxSizing: "border-box",
//             // width: DRAWER_WIDTH,
//             bgcolor: "rgb(17, 20, 28)",
//           },
//         }}
//       >
//         {drawer}
//       </Drawer>

//       {/* Desktop Permanent Drawer */}
//       <Drawer
//         variant="permanent"
//         sx={{
//           display: { xs: "none", md: "block" },
//           "& .MuiDrawer-paper": {
//             boxSizing: "border-box",
//             // width: DRAWER_WIDTH,
//             bgcolor: "rgb(17, 20, 28)",
//             border: "none",
//           },
//         }}
//         open
//       >
//         {drawer}
//       </Drawer>

//       {/* //modal */}
//       <Modal
//         open={logoutOpen}
//         onClose={handleLogoutClose}
//         aria-labelledby="logout-modal-title"
//         aria-describedby="logout-modal-description"
//       >
//         <Box sx={{ ...style, width: 350, textAlign: "center" }}>
//           <Typography
//             id="logout-modal-title"
//             variant="h6"
//             component="h2"
//             mb={2}
//           >
//             Are you sure you want to logout?
//           </Typography>

//           <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
//             <Button variant="outlined" onClick={handleLogoutClose}>
//               Cancel
//             </Button>
//             <Button
//               variant="contained"
//               color="error"
//               sx={{
//                 //  backgroundColor: "#6366F1"
//                 backgroundColor : primary,
//                  }}
//               onClick={handleLogoutConfirm}
//             >
//               Logout
//             </Button>
//           </Box>
//         </Box>
//       </Modal>
//     </Box>
//   );
// }





